// Read from runtime injection (window._env_) first, then build-time process.env
const runtimeEnv =
  (typeof window !== 'undefined' && (window as any)._env_) || {};
const env = (key: string) => runtimeEnv[key] ?? process.env[key];

const DefaultConfigs = {
  REACT_APP_ENV: env('REACT_APP_ENV') || 'local',
  REACT_APP_NUMBER_DECIMAL_DISPLAY:
    env('REACT_APP_NUMBER_DECIMAL_DISPLAY') || 8,

  // RESTful APIs
  REACT_APP_URL_API_MAIN_CLIENT_SIDE: env('REACT_APP_URL_API_MAIN_CLIENT_SIDE'),
  REACT_APP_URL_API_MAIN_STORAGE_SIDE: env(
    'REACT_APP_URL_API_MAIN_STORAGE_SIDE',
  ),

  // Firebase
  REACT_APP_FIREBASE_API_KEY: env('REACT_APP_FIREBASE_API_KEY'),
  REACT_APP_FIREBASE_AUTH_DOMAIN: env('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  REACT_APP_FIREBASE_PROJECT_ID: env('REACT_APP_FIREBASE_PROJECT_ID'),
  REACT_APP_FIREBASE_STORAGE_BUCKET: env('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: env(
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  ),
  REACT_APP_FIREBASE_APP_ID: env('REACT_APP_FIREBASE_APP_ID'),
  REACT_APP_FIREBASE_MEASUREMENT_ID: env('REACT_APP_FIREBASE_MEASUREMENT_ID'),

  REACT_APP_UPLOAD_AVT: env('REACT_APP_UPLOAD_AVT'),
  REACT_APP_CF_TURNSTILE_SITE_KEY: env('REACT_APP_CF_TURNSTILE_SITE_KEY'),
};

type EnvKey = keyof typeof DefaultConfigs;
type NumericEnvKey = 'REACT_APP_NUMBER_DECIMAL_DISPLAY';
type StringEnvKey = Exclude<EnvKey, NumericEnvKey>;

export function getEnv(key: NumericEnvKey): string | number;
export function getEnv(key: StringEnvKey): string;
export function getEnv(key: EnvKey): string | number {
  return DefaultConfigs[key] ?? '';
}

export const isDev = getEnv('REACT_APP_ENV') !== 'production';
